import { render, staticRenderFns } from "./annex.vue?vue&type=template&id=15439195&scoped=true"
import script from "./annex.vue?vue&type=script&lang=js"
export * from "./annex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15439195",
  null
  
)

export default component.exports